import React, {useEffect, useState} from "react";
import {com,} from "../../../../provider_api";
import {priceToString} from "../../../../util/PriceUtil";
import {shortDateTimeFormat2} from "../../../../util/DateTimeUtils";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {useParams} from "react-router-dom";
import {LinkWithParams} from "../../../../util/NavUtils";
import {UseRefundPayment} from "../../../../util/RpcHooks/UseRefundPayment";
import RefundPaymentRequest = com.onkensu.platform.billing.RefundPaymentRequest;
import GetStripePaymentsRequest = com.onkensu.platform.billing.GetStripePaymentsRequest;
import {useGetStripePayments} from "../../../../util/RpcHooks/GetStripePayments";
import { ActionButton } from "../../../../util/UI/ActionButton";

export const PaymentDetails = () => {

  const {paymentId} = useParams();
  const paymentsRpc = useGetStripePayments();
  const refundRpc = UseRefundPayment();

  const [note, setNote] = useState('');

  const refund = () => {

    if (!window.confirm(`Are you sure you want to refund this transaction, with note '${note}'?`)) {
      return;
    }

    refundRpc.send(new RefundPaymentRequest({
      paymentId: paymentId,
      note: note
    }));
  }

  useEffect(() => {
    paymentsRpc.send(new GetStripePaymentsRequest({
      transactionId: paymentId,
    }));
  }, [])

  if ((paymentsRpc?.payments?.length ?? 0) > 1) {
    return <div className={'ErrorText'}>Error: Multiple payments loaded.</div>;
  }

  const transaction = paymentsRpc?.payments?.length ? paymentsRpc.payments[0] : null;

  return <div className={'NonScrollingToolPage'}>

    {/* There is no "back to payments" button because the user may have come from two
     different locations - the "all payments" list or a client's payments list */}
    <TabbedPageHeader pageTitle={'Payment details'}/>

    <div className={'ProviderToolAreaContent'}>

      {transaction && <>

        <div>
          <b>Payment ID:</b> {transaction?.paymentId}
        </div>

        <div>
          <b>Created:</b> {shortDateTimeFormat2(transaction?.createdTimestampMs)}
        </div>

        <div>
          <b>User ID:</b>&nbsp;
          <span style={{textDecoration: 'underline'}}>
          <LinkWithParams to={`/clients/${transaction?.userId}`}>{transaction?.userId}</LinkWithParams>
        </span>
        </div>

        <div>
          <b>Price:</b> {priceToString(transaction?.price, true)}
        </div>

        <div>
          <b>Status:</b> {transaction?.status}
        </div>

        <div>
          <b>Purchased:</b> {transaction?.purchasedThingName}
        </div>
        
      </>}
      
      <br/>

      {paymentsRpc.rpcState.state == 'pending' && <div>Loading payment details...</div>}
      {paymentsRpc.rpcState.state == 'success' && !transaction && <div>Payment not found!</div>}
      {paymentsRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{paymentsRpc.rpcState.message}</div>}

      <br/><br/>

      <div className={'HorizontalFlex Gap20'}>
        <div>
          <ActionButton smaller secondary onClick={refund}>
            Initiate a refund
          </ActionButton>
        </div>
        <input style={{flex: 1, margin: 2, padding: 4}}
               onChange={e => setNote(e.target.value)}
               placeholder={'Enter a note for this refund'}
               value={note} type={'text'}/>
      </div>

      {refundRpc.rpcState.state == 'pending' && <div>Attempting refund...</div>}
      {refundRpc.rpcState.state == 'success' && <div>Refund successful</div>}
      {refundRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{refundRpc.rpcState.message}</div>}


    </div>
  </div>
}
